import $ from "jquery";

export default class LivestreamModal {
  constructor() {
    this.modals = $(".js-livestream-modal");
    this.triggers = $(".js-livestream-trigger");
    this.closeButtons = $(".js-livestream-close");
    this.activeModal = null;

    this.bindEvents();
  }

  bindEvents() {
    // Open modal
    this.triggers.on("click", (e) => {
      e.preventDefault();
      const modalId = $(e.currentTarget).data("modal-id");
      this.openModal(modalId);
    });

    // Close modal
    this.closeButtons.on("click", (e) => {
      const modalId = $(e.currentTarget)
        .closest(".js-livestream-modal")
        .data("modal-id");
      this.closeModal(modalId);
    });

    // Close on escape key
    $(document).on("keydown", (e) => {
      if (e.key === "Escape" && this.activeModal) {
        this.closeModal(this.activeModal.data("modal-id"));
      }
    });
  }

  openModal(modalId) {
    const modal = $(`.js-livestream-modal[data-modal-id="${modalId}"]`);
    modal.addClass("is-active");
    this.activeModal = modal;
    $("body").css("overflow", "hidden");
  }

  closeModal(modalId) {
    const modal = $(`.js-livestream-modal[data-modal-id="${modalId}"]`);
    modal.removeClass("is-active");
    this.activeModal = null;
    $("body").css("overflow", "");
  }
}
